import { render, staticRenderFns } from "./configVersionForm.vue?vue&type=template&id=4a18f26f&scoped=true&"
import script from "./configVersionForm.vue?vue&type=script&lang=js&"
export * from "./configVersionForm.vue?vue&type=script&lang=js&"
import style0 from "./configVersionForm.vue?vue&type=style&index=0&id=4a18f26f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18f26f",
  null
  
)

export default component.exports